export default "__VITE_ASSET__aa4xsss6__"